import * as React from 'react';
import LandingHeader from '@/components/organisms/landing/LandingHeader';
import Footer from '@/components/organisms/common/Footer';

export type BaseTemplatePropType = {
  header?: React.ReactNode;
  children?: React.ReactNode;
  headerShow: boolean;
};

const BaseTemplate = ({ children, headerShow }: BaseTemplatePropType) => (
  <div className="flex flex-col h-full">
    <div className="min-h-screen">
      {headerShow && <LandingHeader layoutFixed={false} mode="light" />}
      <main className="main container mx-auto w-full h-full flex-grow">{children}</main>
    </div>
    <Footer />
  </div>
);

BaseTemplate.defaultProps = {
  headerShow: false,
};

export default BaseTemplate;
